import React from 'react';
import { ChevronDown } from 'lucide-react';

interface FormSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: React.ReactNode;
  hint?: string;
  error?: string;
  containerClassName?: string;
  leadingIcon?: React.ReactNode;
  labelClassName?: string;
}

const baseSelectClasses =
  'w-full appearance-none rounded-xl border border-gray-200 bg-white/90 px-4 py-2.5 text-sm font-medium text-gray-800 transition-all focus:border-purple-500 focus:outline-none focus:ring-4 focus:ring-purple-100 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400 shadow-sm';

const FormSelect: React.FC<FormSelectProps> = ({
  label,
  hint,
  error,
  containerClassName = '',
  leadingIcon,
  labelClassName = 'uppercase',
  className = '',
  children,
  disabled,
  ...rest
}) => {
  const hasIcon = Boolean(leadingIcon);

  return (
    <div className={`space-y-2 ${containerClassName}`}>
      {label && (
        <label className={`text-xs font-semibold tracking-wide text-gray-500 ${labelClassName}`}>
          {label}
        </label>
      )}
      <div className="relative">
        {hasIcon && (
          <div className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
            {leadingIcon}
          </div>
        )}
        <select
          className={`${baseSelectClasses} ${
            hasIcon ? 'pl-11 pr-10' : 'pl-4 pr-10'
          } ${className}`}
          disabled={disabled}
          {...rest}
        >
          {children}
        </select>
        <div className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-400">
          <ChevronDown size={16} strokeWidth={2} />
        </div>
      </div>
      {error ? (
        <p className="text-xs font-medium text-rose-500">{error}</p>
      ) : hint ? (
        <p className="text-xs text-gray-400">{hint}</p>
      ) : null}
    </div>
  );
};

export default FormSelect;

